import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@triplabo/web/App';
import '@triplabo/web/i18n';

import '@triplabo/web/styles/index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
